export default __webpack_public_path__ + "static/object-tile-anatomy-light-46998d02e1494877152477daf83c08c6a324c4d1b8218373edebed2eceb8301a.png";